import { DefaultColors } from 'common/statuses/StatusColors';
import StatusTypes from 'common/statuses/StatusTypes';

export type DefaultStatus = {
  color: string;
  name: string;
  order: number;
  showInPublicRoadmap: boolean;
  type: StatusTypes;
};

const DefaultPostStatuses = [
  {
    color: DefaultColors.Open,
    name: 'open',
    order: 0,
    showInPublicRoadmap: false,
    type: StatusTypes.Initial,
  },
  {
    color: DefaultColors.UnderReview,
    name: 'under review',
    order: 1,
    showInPublicRoadmap: false,
    type: StatusTypes.Active,
  },
  {
    color: DefaultColors.Planned,
    name: 'planned',
    order: 2,
    showInPublicRoadmap: true,
    type: StatusTypes.Active,
  },
  {
    color: DefaultColors.InProgress,
    name: 'in progress',
    order: 3,
    showInPublicRoadmap: true,
    type: StatusTypes.Active,
  },
  {
    color: DefaultColors.Complete,
    name: 'complete',
    order: 4,
    showInPublicRoadmap: true,
    type: StatusTypes.Complete,
  },
  {
    color: DefaultColors.Closed,
    name: 'closed',
    order: 5,
    showInPublicRoadmap: false,
    type: StatusTypes.Closed,
  },
];

export const DefaultChangelogRoadmapStatuses = ['under review', 'planned', 'in progress'];
export const DefaultRoadmapStatuses = ['planned', 'in progress', 'complete'];

export default DefaultPostStatuses;
